import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
  serviceId: string;
};

const removeServiceFromCart: ServiceMethod<void, Params> =
  (httpClient) => async (data, options) => {
    const { cartId, serviceId } = data;

    const { body: response } = await httpClient.delete<void, Params>(
      '/api/v3/carts/{cartId}/services/{serviceId}',
      {
        ...options,
        params: {
          cartId,
          serviceId,
        },
      }
    );

    return response;
  };

export default removeServiceFromCart;
